(() => {
  const responses = {
    "Shopping & Gifts": {
      title: "Let’s find the right place to start.",
      message: "Browse helpful guides, peek into the Pikeville showroom, or explore the larger online catalog. If you need a person, send the team a question from here too.",
      actions: [{ action: "guides", label: "Explore Helpful Guides" }, { action: "showroom", label: "Peek Into the Showroom" }, { action: "catalog", label: "Browse the Online Catalog" }]
    },
    "Repairs & Services": {
      title: "Start with the service you need.",
      message: "Our guides cover jewelry care and repair, sizing, cleaning, watches, and other common service questions. If your piece needs an in-person look, the team can help with the next step.",
      actions: [{ action: "guides", label: "Explore Service Guides" }]
    },
    "Selling & Appraisals": {
      title: "We’ll help you know what to bring.",
      message: "Start with our guides for selling gold and silver or appraisals, then contact the team if you want to check details before your visit.",
      actions: [{ action: "guides", label: "Explore Helpful Guides" }]
    },
    "Ask the Team": {
      title: "Ask away.",
      message: "Tell us what you’re looking for, what you have, or what you’re unsure about. Your message goes directly to the Castles Jewelry & Gifts team.",
      actions: []
    },
    "Engagement Rings": {
      title: "A fine place to begin.",
      message: "You can design a ring, browse styles online, or send the Castles Jewelry & Gifts team your questions about size, stone, metal, style, and budget.",
      actions: [{ action: "ring", label: "Open Ring Design Center" }, { action: "catalog", label: "Browse the Online Catalog" }]
    },
    "Showroom Item": {
      title: "Let’s take a closer look.",
      message: "The showroom peek is a gallery, not a live inventory list. Save the pieces you love, then use the showroom item number when you ask the Castles Jewelry & Gifts team about a specific piece.",
      actions: [{ action: "showroom", label: "Peek Into the Showroom" }]
    },
    "Jewelry Repair": {
      title: "Let’s get it looked at properly.",
      message: "Bring the piece with you and tell us what you’ve noticed. Final repair options and pricing require an in-person inspection, because the safest repair depends on the piece itself.",
      actions: [{ action: "/?guides=1", label: "Explore Repair Guides" }]    },
    "Appraisals": {
      title: "Yes, Castles Jewelry & Gifts handles appraisals.",
      message: "The details can depend on what you’re bringing and why you need the appraisal. Our guides can explain what to bring, or you can send the team a question before your visit.",
      actions: [{ action: "/?guides=1&q=appraisal", label: "Read About Appraisals" }]
    },
    "Financing & Insurance": {
      title: "Let’s get you to the right option.",
      message: "Financing applications are handled securely through the providers linked in Payment Options. For jewelry-insurance questions, the Castles Jewelry & Gifts team can help point you toward the information you need.",
      actions: [{ action: "/#payment-options", label: "View Payment Options" }, { action: "/?guides=1&q=insurance", label: "Explore Insurance Guides" }]
    },
    "Watch Battery": {
      title: "We can check your watch.",
      message: "Include the brand and model if you know them. Please note that Castles Jewelry & Gifts cannot service Timex or Michael Kors watches.",
      actions: [{ action: "/?guides=1&q=watch", label: "Explore Watch Guides" }]
    },
    "Layaway": {
      title: "A practical plan for a meaningful piece.",
      message: "Castles Jewelry & Gifts offers up to 12 months of layaway with 20% down and no monthly minimum. Use the calculator for a quick estimate; item eligibility and final terms are confirmed in store.",
      actions: [{ action: "/#payment-options", label: "Open the Layaway Calculator" }, { action: "/?guides=1&q=layaway", label: "Read About Layaway" }]
    },
    "Gift Guidance": {
      title: "Bring the clues. We’ll help with the rest.",
      message: "Tell us the occasion, budget, favorite metal, style, or pieces they already wear. Photos and inspiration links help too.",
      actions: [{ action: "guides", label: "View Helpful Guides" }, { action: "showroom", label: "Peek Into the Showroom" }, { action: "catalog", label: "Browse the Online Catalog" }]
    },
    "Sell Gold or Silver": {
      title: "Bring your pieces in for guidance.",
      message: "The Castles Jewelry & Gifts team buys many gold and silver pieces and can walk you through the in-store process clearly and respectfully.",
      actions: [{ action: "guides", label: "View Helpful Guides" }]
    },
    "Custom Design": {
      title: "Let’s talk about what you imagine.",
      message: "Share your idea, heirloom piece, inspiration photo, stone, or metal preference. The team can explain the next in-store step.",
      actions: [{ action: "ring", label: "Open Ring Design Center" }]
    },
    "General Question": {
      title: "You’re welcome to wander.",
      message: "Browse helpful guides, take a peek inside the local showroom, or explore the larger online catalog. No pressure, and no need to know exactly what you’re looking for yet.",
      actions: [{ action: "guides", label: "Explore Helpful Guides" }, { action: "showroom", label: "Peek Into the Showroom" }, { action: "catalog", label: "Browse the Online Catalog" }]
    }
  };

  const showroomCompliments = [
    "Excellent choice. That one has presence.",
    "You have a good eye.",
    "That one deserves a closer look.",
    "A very respectable choice, if I may say so.",
    "Now that is worth remembering.",
    "I can see why that one caught your attention."
  ];

  const escapeHTML = (value = "") => String(value).replace(/[&<>'"]/g, (char) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" }[char]));

  const originalDocumentTitle = document.title;

  function setV16View(mode) {
    const showroomMode = mode === "showroom";
    const guidesMode = mode === "guides";
    const demoGuideMode = mode === "guide-demo";
    document.querySelectorAll("[data-cv15-home-root]").forEach((el) => { el.hidden = showroomMode || guidesMode || demoGuideMode; });
    document.querySelectorAll("[data-cv15-showroom-root]").forEach((el) => { el.hidden = !showroomMode; });
    document.querySelectorAll("[data-cv16-guides-root]").forEach((el) => { el.hidden = !guidesMode; });
    document.querySelectorAll("[data-cv16-guide-demo-root]").forEach((el) => { el.hidden = !demoGuideMode; });
    document.documentElement.classList.toggle("cv15-showroom-mode", showroomMode);
    document.documentElement.classList.toggle("cv16-guides-mode", guidesMode);
    document.documentElement.classList.toggle("cv16-guide-demo-mode", demoGuideMode);
    if (showroomMode) document.title = `Peek Inside the Showroom – Castles Jewelry & Gifts`;
    else if (guidesMode) document.title = `Services & Expertise – Castles Jewelry & Gifts`;
    else if (demoGuideMode) document.title = `Services & Expertise Guide – Castles Jewelry & Gifts`;
    else document.title = originalDocumentTitle;
  }

  function applyV16Route() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("showroom") === "1") setV16View("showroom");
    else if (params.get("guides") === "1") setV16View("guides");
    else if (params.get("guide-demo")) {
      setV16View("guide-demo");
      const demoId = params.get("guide-demo");
      document.querySelectorAll("[data-cv16-demo-article]").forEach((article) => { article.hidden = article.dataset.cv16DemoArticle !== demoId; });
    }
    else setV16View("home");
  }

  function initRoot(root) {
    if (root.dataset.cv12Ready === "true") return;
    root.dataset.cv12Ready = "true";

    root.querySelectorAll("[data-cv12-mobile-menu]").forEach((menu) => {
      menu.querySelectorAll("a, [data-cv12-steward]").forEach((item) => item.addEventListener("click", () => menu.removeAttribute("open")));
    });

    root.querySelectorAll("[data-cv12-slider]").forEach((slider) => {
      const slides = [...slider.querySelectorAll("[data-cv12-slide]")];
      const dots = [...slider.querySelectorAll("[data-cv12-dot]")];
      if (slides.length < 2) return;
      let current = 0;

      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle("is-active", i === current));
        dots.forEach((dot, i) => {
          dot.classList.toggle("is-active", i === current);
          dot.setAttribute("aria-current", i === current ? "true" : "false");
        });
      };

      slider.querySelector("[data-cv12-prev]")?.addEventListener("click", () => show(current - 1));
      slider.querySelector("[data-cv12-next]")?.addEventListener("click", () => show(current + 1));
      dots.forEach((dot) => dot.addEventListener("click", () => show(Number(dot.dataset.cv12Dot))));
    });

    root.querySelectorAll("[data-cv12-layaway]").forEach((calculator) => {
      const input = calculator.querySelector("[data-cv12-layaway-input]");
      const downOutput = calculator.querySelector("[data-cv12-layaway-down]");
      const remainingOutput = calculator.querySelector("[data-cv12-layaway-remaining]");
      const rate = Math.max(0, Number(calculator.dataset.cv12LayawayRate) || 20) / 100;
      const currency = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
      const update = () => {
        const amount = Math.max(0, Number(input?.value) || 0);
        if (downOutput) downOutput.textContent = currency.format(amount * rate);
        if (remainingOutput) remainingOutput.textContent = currency.format(amount * (1 - rate));
      };
      input?.addEventListener("input", update);
      update();
    });

    const widget = root.querySelector("[data-cv12-steward-widget]");
    if (widget) {
      const panel = widget.querySelector(".cv12-steward-panel");
      const toggle = widget.querySelector("[data-cv12-steward-toggle]");
      const form = widget.querySelector(".cv12-steward-form");
      const topicInput = widget.querySelector("[data-cv12-topic-input]");
      const intro = widget.querySelector("[data-cv12-steward-intro]");
      const directory = widget.querySelector("[data-cv12-steward-directory]");
      const backButton = widget.querySelector("[data-cv12-steward-back]");
      const response = widget.querySelector("[data-cv12-steward-response]");
      const guidanceActions = widget.querySelector("[data-cv12-steward-guidance-actions]");
      const guidanceLinks = [...widget.querySelectorAll("[data-cv12-guidance-action]")];
      const formCTA = widget.querySelector("[data-cv12-form-cta]");
      const messageField = form?.querySelector('textarea[name="contact[body]"]');
      const itemTitleInput = form?.querySelector("[data-cv12-item-title-input]");
      const itemNumberInput = form?.querySelector("[data-cv12-item-number-input]");
      const itemImageInput = form?.querySelector("[data-cv12-item-image-input]");
      const pageInput = form?.querySelector("[data-cv12-page-input]");

      const close = () => {
        widget.classList.remove("is-open");
        toggle?.setAttribute("aria-expanded", "false");
        panel?.setAttribute("aria-hidden", "true");
      };

      const resolveDestination = (action) => {
        const destinations = {
          catalog: widget.dataset.cv12CatalogUrl || "https://castlesjewelryandgifts.jewelershowcase.com/",
          ring: widget.dataset.cv12RingUrl || "https://castlesjewelryandgifts.jewelershowcase.com/browse/wedding-and-engagement",
          showroom: "/?showroom=1",
          guides: "/?guides=1"
        };
        return destinations[action] || action || destinations.catalog;
      };

      const configureGuidanceLink = (link, config) => {
        if (!link) return;
        if (!config) {
          link.hidden = true;
          link.removeAttribute("href");
          return;
        }
        const href = resolveDestination(config.action);
        link.hidden = false;
        link.href = href;
        link.textContent = config.label || "Continue";
        if (/^https?:\/\//.test(href) && !href.startsWith(window.location.origin)) {
          link.target = "_blank";
          link.rel = "noopener noreferrer";
        } else {
          link.removeAttribute("target");
          link.removeAttribute("rel");
        }
      };

      const setGuidance = (actions = []) => {
        const list = (Array.isArray(actions) ? actions : [actions]).filter(Boolean);
        guidanceLinks.forEach((link, index) => configureGuidanceLink(link, list[index]));
        if (guidanceActions) guidanceActions.hidden = list.length === 0;
      };

      guidanceLinks.forEach((link) => link.addEventListener("click", () => close()));

      const clearItemContext = () => {
        if (formCTA) formCTA.textContent = "Send a Question to Our Team";
        if (itemTitleInput) itemTitleInput.value = "";
        if (itemNumberInput) itemNumberInput.value = "";
        if (itemImageInput) itemImageInput.value = "";
        if (pageInput) pageInput.value = window.location.href;
      };

      const showContextView = () => {
        if (intro) intro.hidden = true;
        if (directory) directory.hidden = true;
        if (backButton) backButton.hidden = false;
        if (response) response.hidden = false;
        if (formCTA) formCTA.hidden = false;
      };

      const resetDirectory = () => {
        if (intro) intro.hidden = false;
        if (directory) directory.hidden = false;
        if (backButton) backButton.hidden = true;
        if (response) {
          response.hidden = true;
          response.innerHTML = "";
        }
        if (formCTA) {
          formCTA.hidden = true;
          formCTA.textContent = "Send a Question to Our Team";
        }
        form?.classList.remove("is-open");
        widget.querySelectorAll("[data-cv12-topic]").forEach((button) => button.classList.remove("is-selected"));
        setGuidance([]);
        if (topicInput) topicInput.value = "General Question";
        if (messageField) messageField.value = "";
        clearItemContext();
        widget.querySelector(".cv12-steward-body")?.scrollTo({ top: 0, behavior: "auto" });
      };

      const selectTopic = (topic) => {
        const safeTopic = responses[topic] ? topic : "General Question";
        const { title, message, actions } = responses[safeTopic];
        showContextView();
        form?.classList.remove("is-open");
        widget.querySelectorAll("[data-cv12-topic]").forEach((button) => button.classList.toggle("is-selected", button.dataset.cv12Topic === safeTopic));
        if (topicInput) topicInput.value = safeTopic;
        if (messageField) messageField.value = "";
        if (response) response.innerHTML = `<p class="cv12-card-kicker">${escapeHTML(safeTopic)}</p><h3>${escapeHTML(title)}</h3><p>${escapeHTML(message)}</p>`;
        if (formCTA) formCTA.hidden = false;
        setGuidance(actions || []);
        clearItemContext();
      };

      const openContactForm = () => {
        if (!form) return;
        form.classList.add("is-open");
        if (formCTA) formCTA.hidden = true;
        form.querySelector("input:not([type=hidden])")?.focus();
      };

      const selectShowroomItem = (title, itemNumber, itemImage) => {
        const itemTitle = title || "this showroom piece";
        const itemLabel = itemNumber ? `Showroom Item #${itemNumber}` : "Showroom Peek";
        const compliment = showroomCompliments[Math.floor(Math.random() * showroomCompliments.length)];
        showContextView();
        form?.classList.remove("is-open");
        widget.querySelectorAll("[data-cv12-topic]").forEach((button) => button.classList.remove("is-selected"));
        if (topicInput) topicInput.value = itemNumber ? `Showroom Item — #${itemNumber}` : "Showroom Item";
        if (response) response.innerHTML = `<p class="cv12-card-kicker">${escapeHTML(itemLabel)}</p><h3>${escapeHTML(compliment)}</h3><p>You’re looking at <strong>${escapeHTML(itemTitle)}</strong>. Save it with the heart, or email the Castles Jewelry & Gifts team. I’ll include the item details automatically so you do not have to copy them.</p>`;
        setGuidance([{ action: "showroom", label: "Peek Into the Showroom" }]);
        if (formCTA) {
          formCTA.hidden = false;
          formCTA.textContent = "Email Our Team About This Piece";
        }
        if (messageField) messageField.value = `Hi! I’m interested in ${itemTitle}${itemNumber ? ` (Showroom Item #${itemNumber})` : ""} from the Showroom Peek. Could you tell me more about it?`;
        if (itemTitleInput) itemTitleInput.value = itemTitle;
        if (itemNumberInput) itemNumberInput.value = itemNumber || "";
        if (itemImageInput) itemImageInput.value = itemImage || "";
        if (pageInput) pageInput.value = window.location.href;
      };

      const open = (topic, itemTitle, itemNumber, itemImage) => {
        widget.classList.add("is-open");
        toggle?.setAttribute("aria-expanded", "true");
        panel?.setAttribute("aria-hidden", "false");
        if (itemTitle || itemNumber) selectShowroomItem(itemTitle, itemNumber, itemImage);
        else if (topic) selectTopic(topic);
        else resetDirectory();
      };

      root.querySelectorAll("[data-cv12-steward]").forEach((button) => button.addEventListener("click", () => open(button.dataset.cv12Prefill, button.dataset.cv12ShowroomItem, button.dataset.cv12ItemNumber, button.dataset.cv12ItemImage)));
      toggle?.addEventListener("click", () => widget.classList.contains("is-open") ? close() : open());
      widget.querySelector("[data-cv12-steward-close]")?.addEventListener("click", close);
      backButton?.addEventListener("click", resetDirectory);
      widget.querySelectorAll("[data-cv12-topic]").forEach((button) => button.addEventListener("click", () => {
        selectTopic(button.dataset.cv12Topic);
        if (button.hasAttribute("data-cv12-open-topic-form")) openContactForm();
      }));
      widget.querySelector("[data-cv12-open-form]")?.addEventListener("click", () => {
        if (!form) return;
        const willOpen = !form.classList.contains("is-open");
        form.classList.toggle("is-open", willOpen);
        if (formCTA) formCTA.hidden = willOpen;
        if (willOpen) form.querySelector("input:not([type=hidden])")?.focus();
      });
      document.addEventListener("keydown", (event) => { if (event.key === "Escape") close(); });

      if (form?.querySelector(".cv12-form-status")) {
        open(topicInput?.value || "General Question");
        form.classList.add("is-open");
      }

      root.cv12Steward = { open, close, selectShowroomItem };
    }

    const filterButtons = [...root.querySelectorAll("[data-cv12-filter]")];
    const articles = [...root.querySelectorAll("[data-cv12-category]")];
    filterButtons.forEach((button) => button.addEventListener("click", () => {
      const filter = button.dataset.cv12Filter;
      filterButtons.forEach((item) => item.classList.toggle("is-active", item === button));
      articles.forEach((article) => { article.hidden = filter !== "all" && !article.dataset.cv12Category.split(" ").includes(filter); });
    }));

    const showroom = root.querySelector("[data-cv14-showroom]");
    if (showroom) {
      const storageKey = "castles-showroom-saved-v1";
      const cards = [...showroom.querySelectorAll("[data-cv14-card]")];
      const filters = [...showroom.querySelectorAll("[data-cv14-filter]")];
      const search = showroom.querySelector("[data-cv14-search]");
      const savedToggle = showroom.querySelector("[data-cv14-saved-toggle]");
      const savedCount = showroom.querySelector("[data-cv14-saved-count]");
      const noResults = showroom.querySelector("[data-cv14-no-results]");
      const resultsStatus = showroom.querySelector("[data-cv14-results-status]");
      const modal = root.querySelector("[data-cv14-detail-modal]");
      let activeFilter = "all";
      let savedOnly = false;
      let activeCard = null;
      let saved = new Set();

      try {
        const parsed = JSON.parse(localStorage.getItem(storageKey) || "[]");
        if (Array.isArray(parsed)) saved = new Set(parsed);
      } catch (_) {}
      const currentIds = new Set(cards.map((card) => card.dataset.cv14Id).filter(Boolean));
      saved = new Set([...saved].filter((id) => currentIds.has(id)));

      const persistSaved = () => {
        try { localStorage.setItem(storageKey, JSON.stringify([...saved])); } catch (_) {}
      };

      const updateSavedUI = () => {
        if (savedCount) savedCount.textContent = String(saved.size);
        cards.forEach((card) => {
          const isSaved = saved.has(card.dataset.cv14Id);
          const button = card.querySelector("[data-cv14-save]");
          if (button) {
            button.classList.toggle("is-saved", isSaved);
            button.setAttribute("aria-pressed", isSaved ? "true" : "false");
            button.textContent = isSaved ? "♥" : "♡";
          }
        });
        if (savedToggle) {
          savedToggle.classList.toggle("is-active", savedOnly);
          savedToggle.setAttribute("aria-pressed", savedOnly ? "true" : "false");
        }
        if (modal && activeCard) {
          const modalSave = modal.querySelector("[data-cv14-modal-save]");
          const isSaved = saved.has(activeCard.dataset.cv14Id);
          if (modalSave) modalSave.textContent = isSaved ? "♥ Saved" : "♡ Save This Piece";
        }
      };

      const applyFilters = () => {
        const query = (search?.value || "").trim().toLowerCase();
        let visible = 0;
        cards.forEach((card) => {
          const categoryMatch = activeFilter === "all" || card.dataset.cv14Category === activeFilter;
          const searchMatch = !query || (card.dataset.cv14SearchText || "").includes(query);
          const savedMatch = !savedOnly || saved.has(card.dataset.cv14Id);
          const show = categoryMatch && searchMatch && savedMatch;
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (noResults) noResults.hidden = visible !== 0 || cards.length === 0;
        if (resultsStatus) {
          if (!cards.length) resultsStatus.textContent = "";
          else if (savedOnly) resultsStatus.textContent = `${visible} saved ${visible === 1 ? "piece" : "pieces"} shown.`;
          else resultsStatus.textContent = `${visible} ${visible === 1 ? "piece" : "pieces"} shown.`;
        }
      };

      const toggleSaved = (card) => {
        const id = card?.dataset.cv14Id;
        if (!id) return;
        if (saved.has(id)) saved.delete(id);
        else saved.add(id);
        persistSaved();
        updateSavedUI();
        applyFilters();
      };

      filters.forEach((button) => button.addEventListener("click", () => {
        activeFilter = button.dataset.cv14Filter || "all";
        filters.forEach((item) => item.classList.toggle("is-active", item === button));
        applyFilters();
      }));
      search?.addEventListener("input", applyFilters);
      savedToggle?.addEventListener("click", () => {
        savedOnly = !savedOnly;
        updateSavedUI();
        applyFilters();
      });
      cards.forEach((card) => card.querySelector("[data-cv14-save]")?.addEventListener("click", () => toggleSaved(card)));

      const openDetails = (card) => {
        if (!modal || !card) return;
        activeCard = card;
        const read = (selector) => card.querySelector(selector)?.textContent?.trim() || "";
        const image = read("[data-cv14-detail-image]");
        const modalImage = modal.querySelector("[data-cv14-modal-image]");
        const title = read("[data-cv14-detail-title]") || "Showroom Favorite";
        const item = read("[data-cv14-detail-item]");
        const category = read("[data-cv14-detail-category]");
        const badge = read("[data-cv14-detail-badge]") || "Showroom Peek";
        const copyNode = card.querySelector("[data-cv14-detail-copy]");
        if (modalImage) {
          modalImage.src = image;
          modalImage.alt = title;
          modalImage.closest(".cv14-detail-image-wrap")?.classList.toggle("is-empty", !image);
        }
        const titleNode = modal.querySelector("[data-cv14-modal-title]");
        const itemNode = modal.querySelector("[data-cv14-modal-item]");
        const categoryNode = modal.querySelector("[data-cv14-modal-category]");
        const badgeNode = modal.querySelector("[data-cv14-modal-badge]");
        const modalCopy = modal.querySelector("[data-cv14-modal-copy]");
        if (titleNode) titleNode.textContent = title;
        if (itemNode) itemNode.textContent = item ? `Item #${item}` : "";
        if (categoryNode) categoryNode.textContent = category;
        if (badgeNode) badgeNode.textContent = badge;
        if (modalCopy) modalCopy.innerHTML = copyNode?.innerHTML || "";
        updateSavedUI();
        if (typeof modal.showModal === "function") modal.showModal();
        else modal.setAttribute("open", "");
      };

      cards.forEach((card) => card.querySelector("[data-cv14-details]")?.addEventListener("click", () => openDetails(card)));
      modal?.querySelector("[data-cv14-detail-close]")?.addEventListener("click", () => modal.close?.());
      modal?.addEventListener("click", (event) => {
        if (event.target === modal) modal.close?.();
      });
      modal?.querySelector("[data-cv14-modal-save]")?.addEventListener("click", () => activeCard && toggleSaved(activeCard));
      modal?.querySelector("[data-cv14-modal-steward]")?.addEventListener("click", () => {
        if (!activeCard) return;
        const title = activeCard.querySelector("[data-cv14-detail-title]")?.textContent?.trim() || "Showroom Favorite";
        const itemNumber = activeCard.querySelector("[data-cv14-detail-item]")?.textContent?.trim() || "";
        modal.close?.();
        const itemImage = activeCard.querySelector("[data-cv14-detail-image]")?.textContent?.trim() || "";
        root.cv12Steward?.open("Showroom Item", title, itemNumber, itemImage);
      });

      updateSavedUI();
      applyFilters();
    }

    const guideLibrary = root.querySelector("[data-cv16-guides-library]");
    if (guideLibrary) {
      const cards = [...guideLibrary.querySelectorAll("[data-cv16-guide-card]")];
      const filters = [...guideLibrary.querySelectorAll("[data-cv16-guide-filter]")];
      const search = guideLibrary.querySelector("[data-cv16-guide-search]");
      const status = guideLibrary.querySelector("[data-cv16-guide-status]");
      const empty = guideLibrary.querySelector("[data-cv16-guide-empty]");
      let activeTag = "all";

      const applyGuideFilters = () => {
        const query = (search?.value || "").trim().toLowerCase();
        let visible = 0;
        cards.forEach((card) => {
          const tags = (card.dataset.cv16Tags || "").trim().split(/\s+/).filter(Boolean);
          const tagMatch = activeTag === "all" || tags.includes(activeTag);
          const searchMatch = !query || (card.dataset.cv16SearchText || "").includes(query);
          const show = tagMatch && searchMatch;
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (status) status.textContent = `${visible} ${visible === 1 ? "guide" : "guides"} shown.`;
        if (empty) empty.hidden = visible !== 0;
      };

      filters.forEach((button) => button.addEventListener("click", () => {
        activeTag = button.dataset.cv16GuideFilter || "all";
        filters.forEach((item) => item.classList.toggle("is-active", item === button));
        applyGuideFilters();
      }));
      search?.addEventListener("input", applyGuideFilters);
      const params = new URLSearchParams(window.location.search);
      const initialQuery = params.get("q") || "";
      if (search && initialQuery) search.value = initialQuery;
      applyGuideFilters();
      if (initialQuery) {
        requestAnimationFrame(() => requestAnimationFrame(() => {
          const firstMatch = cards.find((card) => !card.hidden);
          firstMatch?.scrollIntoView({ behavior: "auto", block: "start" });
        }));
      }
    }

    root.querySelectorAll('a[href*="#"]').forEach((link) => link.addEventListener("click", (event) => {
      const url = new URL(link.href, window.location.href);
      if (url.pathname !== window.location.pathname || url.search !== window.location.search || !url.hash) return;
      const target = document.querySelector(url.hash);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      history.replaceState(null, "", url.hash);
    }));
  }

  const init = () => {
    document.querySelectorAll("[data-cv12-root]").forEach(initRoot);
    applyV16Route();
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:select", (event) => {
    const section = event.target;
    if (section?.querySelector?.("[data-cv15-showroom-root]")) setV16View("showroom");
    else if (section?.querySelector?.("[data-cv16-guides-root]")) setV16View("guides");
    else if (section?.querySelector?.("[data-cv16-guide-demo-root]")) setV16View("guide-demo");
    else if (section?.querySelector?.("[data-cv15-home-root]")) setV16View("home");
  });
  window.addEventListener("popstate", applyV16Route);
})();
